// Site specific main javascript
function is_touch_device() {
    return (('ontouchstart' in window)
         || (navigator.MaxTouchPoints > 0)
         || (navigator.msMaxTouchPoints > 0));
   }

function closeSideNav() {
	// console.log("CLOSE SIDE NAV");
	if(!$(".nav").hasClass("collapsed")){
		$(".nav").addClass("collapsed");
	}
}

function openSideNav() {
	// console.log("OPEN SIDE NAV");
	if($(".nav").hasClass("collapsed")){
		$(".nav").removeClass("collapsed");
	}
}

function initLangNav() {
	// HEADER RELATED
	// HEADER LANG CHOICE
	// Trigger and target
	langChoiceWidget         = $( '#langChoiceWidget' );
	langChoiceTriggerElement = $( '#langChoiceWidget__trigger' );
	langChoiceSubmenuElement = $( '#langChoiceWidget__submenu' );
	if(is_touch_device()){
		// UNBIND EVENT HANDLER IF EXISTANT
		$( langChoiceTriggerElement ).unbind("click");
		// TOUCH DEVICES
		// console.log('TOUCH SCREEN');
		// Use click
		$( langChoiceTriggerElement ).click( function(event){
			// Only active on 992px up
			if($(window).width()>=992){
				event.preventDefault();
				$(".langChoice__active .arrow").toggleClass('arrow-up');
				$( langChoiceSubmenuElement ).toggleClass('visible');
			}
		});
	} else {
		// UNBIND EVENT HANDLER IF EXISTANT
		$( langChoiceWidget ).unbind("mouseover");
		$( langChoiceWidget ).unbind("mouseout");
		// NON TOUCH DEVICES
		// console.log('NON TOUCH SCREEN');
		$( langChoiceWidget ).mouseover(function(){
			$(".langChoice__active .arrow").toggleClass('arrow-up');
			$( langChoiceSubmenuElement ).addClass('visible');
		});
		$( langChoiceWidget ).mouseout(function(){
			$(".langChoice__active .arrow").toggleClass('arrow-up');
			$( langChoiceSubmenuElement ).removeClass('visible');
		});
	}
}


// ON PAGE READY
$(function(){
	// PAGE READY
	//console.log('PAGE READY');

	// INIT LANG NAV
	initLangNav();

});

// RESIZE
var resizingTimeout;
$( window ).resize(function() {
    clearTimeout(resizingTimeout);
    resizingTimeout = setTimeout(doneResizing, 50);
});

function doneResizing(){
	// Window resized loaded
	// console.log('WINDOW RESIZED');
	// INIT LANG NAV
	initLangNav();
}

